import { Link } from "gatsby";
import { Category, Subcategory } from "../../../interfaces/Article.interface";
import "./Breadcumbs.scss";

interface Props {
  selectedSubcategory: Category | Subcategory;
  articleName: string;
}

const Breadcumbs = ({ selectedSubcategory, articleName }: Props) => {
  return (
    <nav className="a-breadcumbs">
      <ul>
        <li>
          <Link aria-label="Regresar al inicio" to="/">
            Centro de ayuda
          </Link>
          <span>/</span>
        </li>
        <li>
          <Link
            aria-label={`Ir a ${selectedSubcategory?.name}`}
            to={selectedSubcategory?.url ?? "/"}
          >
            {selectedSubcategory?.name}
          </Link>
          {articleName && <span className="slash">/</span>}
        </li>
        {articleName && (
          <li>
            <p>{articleName}</p>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Breadcumbs;
